var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 40,
    viewBox: "0 0 54 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 29.828V15.788M27 15.788L32.616 21.404M27 15.788L21.384 21.404M52.272 28.3716C52.272 33.5189 48.3704 37.7195 43.4047 38.252H12.6644C6.57552 37.8378 1.72803 32.7498 1.72803 26.5376C1.72803 20.3846 6.45729 15.3556 12.4871 14.8232C13.3147 7.48686 19.5219 1.74799 27.0887 1.74799C35.1876 1.74799 41.8085 8.31516 41.8085 16.4797C41.8085 17.1897 41.7494 17.8405 41.6903 18.4913C41.9268 18.4913 42.1632 18.4913 42.3997 18.4913C47.8383 18.4321 52.272 22.9286 52.272 28.3716Z",
    stroke: "#28519E",
    strokeWidth: 1.56,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.98aa08c4c7789fec8ed1493c9cdbabd5.svg";
export { ForwardRef as ReactComponent };